import React, { useEffect, useState, Fragment } from 'react';
import Axios from '../../config/axios';
import { Drawer, message } from 'antd';

export default function ShowLogisticsSlider(props) {
    const [state, setState] = useState({
        showDrawer: false,
        loading: true,
        showInfo: {},
        showInfoLoaded: false,
        showDetails: {},
        boothStr: ''
    });

    useEffect(() => {
        getShowInformation();
    }, [props]);

    function hideDrawer() {
        setState({
            ...state,
            showDrawer: false
        });

        setTimeout(() => {
            props.hidePane();
        }, 1000)
    }

    function getShowInformation() {
        var myBoothStr = '';

        const key = "loading";
        message.loading({
            content: 'Loading Show Logistics...',
            key,
            duration: 0,
        });

        Axios.get(`/api/GetShowInformation`, {
            params: {
                id: props.selectedShowCode,
                companyId: props.selectedCustomerId
            }
        }).then(response => {
            //workaround, not sure why showcode is coming back 0 in both objects
            let showMaster = response.data.showMaster;
            let showDetails = response.data.showDetail;

            showMaster.showcode = props.selectedShowCode;
            showDetails.showcode = props.selectedShowCode;

            myBoothStr = showDetails.booth1;
            if (showDetails.booth2) { myBoothStr += ', ' + showDetails.booth2; }
            if (showDetails.booth3) { myBoothStr += ', ' + showDetails.booth3; }

            setState({
                ...state,
                showInfo: showMaster,
                showDetails: showDetails,
                showInfoLoaded: true,
                boothStr: myBoothStr,
                showDrawer: props.showDrawer,
                loading: false
            });

            message.destroy(key);
        }).catch(error => {
            console.log(error);
        });
    }

    function download(name, blob) {
        let postdata = {
            id: props.selectedShowCode.toString(),
            name,
            blob
        };

        console.log(postdata);

        const key = "downloadDoc";
        message.loading({
            content: 'Downloading Service Form...',
            key,
            duration: 0
        });

        Axios.post(`/api/DownloadForm`, postdata, { responseType: 'blob' }
        ).then(response => {
            message.destroy(key);

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = name;
            a.click();
            window.URL.revokeObjectURL(url);

        }).catch(error => {
            console.log(error);
        });

    }

    return (
        <Drawer
            title={`${state.showInfo.name} Show Logistics`}
            placement={'right'}
            onClose={hideDrawer}
            visible={state.showDrawer}
            key='valAttachment'
            width={'75%'}
            closeIcon={<i className="fas fa-chevron-right float-left"></i>}
        >
            {state.loading ? <span>Loading...</span>
                :
                <>
                    <div className="slide-pane-body scrollableDiv">
                        <Fragment>
                            <div className="col col-12 text-center pb-3"><h4>Warehouse/Direct to Show Site Shipping/Breakdown/Dismantle</h4></div>
                            <div className="row pb-5">
                                <div className="text-left col swradiusbordered mr-4 ml-5">
                                    <div className="mb-2 pt-3">
                                        <h4>Warehousing Service Package</h4>
                                        Use of the warehouse for shipments prior to the show is classified "complete service" and will be billed to your company separately by the decorating company. Minimum charge 200 lbs.
                                    </div>
                                    <div className="mb-2">
                                        Rate for the Warehouse Service Package is <span style={{ color: "blue", fontWeight: "bold" }}>{state.showInfo.warehouseRate}</span>. Exhibitors must pay in advance for warehouse shipments.
                                    </div>
                                    <div className="mb-2">
                                        <div>
                                            Package Includes
                                        </div>
                                        <div>
                                            <ol className="pl-5">
                                                <li>Crated, cased or packaged exhibit materials stored at the warehouse for a period of 30 days prior to show opening.</li>
                                                <li>Deliver materials to the exhibit hall and place in exhibit space.</li>
                                                <li>Remove crates, cases etc. at the end of show set-up, return to exhibit space for breakdown.</li>
                                            </ol>
                                        </div>
                                    </div>
                                    <div className="mb-2">
                                        {state.showInfo.shippingFormText &&
                                            <div className="a" style={{ fontSize: "1.00rem", fontWeight: 'bold' }}>
                                                <div onClick={(name, blob) => download(state.showInfo.name.replace(' ', '_') + '_Warehouse_Shipment_Order.pdf', state.showInfo.shippingForm)}>Warehouse Shipment Order Form (click here)</div>
                                            </div>
                                        }

                                        <div className="pb-3">
                                            To verify receipt of your shipment, contact exhibitor services: <span style={{ color: "blue", fontWeight: "bold" }}>{state.showInfo.exhServicesPhone}.</span>
                                        </div>

                                        <div className="pb-4">
                                            <strong>REMINDER:</strong><br />
                                            Shipments may be consigned to the warehouse <b>up to 30 days in advance. Please ship to arrive by <span style={{ color: "blue" }}>{state.showInfo.arriveByDate}.</span> This gives
                                                you a chance to check delivery prior to arriving at the show.</b>
                                        </div>

                                        <div className="pb-1">
                                            <b>WAREHOUSE ADDRESS:</b><br />
                                            {state.showInfo.warehouseName}<br />
                                            {state.showInfo.warehouseFreightCo}<br />
                                            {state.showInfo.warehouseStreet1}<br />
                                            {state.showInfo.warehouseStreet2}<br />
                                            {state.showInfo.warehouseCityStateZip}<br />
                                        </div>

                                        <div>
                                            <b>For:</b><br />
                                            {props.selectedCustomerName}<br />
                                            Booth # {state.showDetails.booth1}
                                        </div>
                                    </div>
                                </div>
                                <div className="text-left col ml-4 mr-5">
                                    <div className="text-left col swradiusbordered mb-1 p-3">
                                        <h4>Direct to Show Site Shipping</h4>

                                        <div className="pb-4">
                                            The exhibit hall does not contain storage facilities, nor will it have personnel on hand to unload shipments until&nbsp;
                                            <span style={{ color: "blue", fontWeight: "bold" }}>{state.showInfo.setupDay1Date}</span>, <b>8:00 a.m.- 6:00 p.m. Any shipments delivered to show site outside of this receiving window will incur a surcharge.</b>&nbsp;
                                            If you plan to ship by common carrier or deliver with your own truck, please plan accordingly.
                                        </div>

                                        <div className="pb-1">
                                            <b>DIRECT TO SHOWSITE:</b><br />
                                            Ship To Arrive: <span style={{ color: "red" }}>BETWEEN 8:00 AM - 6:00 PM ON SET-UP DAY</span><br />
                                            {state.showInfo.location}<br />
                                            Design-2-Part Show<br />
                                            {state.showInfo.street1}<br />
                                            {state.showInfo.city},  {state.showInfo.state}  {state.showInfo.zip}<br />
                                            <span className="a">
                                                {state.showInfo.freightFormText &&
                                                    <div onClick={(name, blob) => this.download(state.showIndicator + '_Shipping Labels.pdf', state.showInfo.freightForm)}><u>Download Shipping Labels</u></div>
                                                }
                                            </span>
                                            <br />
                                        </div>

                                        <div className="pt-2">
                                            <b>For:</b><br />
                                            {props.selectedCustomerName}<br />
                                            Booth # {state.showDetails.booth1}
                                        </div>
                                    </div>
                                    <div className="text-left col swradiusbordered mr-5 p-3">
                                        <h4>Breakdown/Dismantle Instructions</h4>
                                        Dismantling begins at the close of the show. No dismantling is allowed prior to this time. Empty crates will be brought to your booth within one hour of show close.
                                        If you have a truck scheduled to pick up your freight, please have them arrive at the convention hall by 4:30 - 5:00 pm. Please have the driver check in with the
                                        decorator upon arrival with your company name & booth number. The exhibitor must also inform the decorator their trucking company of choice is picking up their freight.<br /><br />
                                        <b>All freight must be off the show floor by 6:30 pm, if not it will be shipped by the show carrier at the exhibitor's expense.</b>
                                        <br /><br />

                                        A freight carrier will be available with bill of ladings and shipping labels at the Hall by 12:30 pm on <span style={{ color: "blue", fontWeight: "bold" }}>{state.showInfo.freightCoOnHand}.</span>

                                    </div>
                                </div>
                            </div>
                            <div className="col col-12 pb-3 swradiusbordered row">
                                <h4>Decorator & Convention Center Service Forms</h4>
                                <div className="text-center col-2 a">
                                    {state.showInfo.electricalFormText &&
                                        <p onClick={(name, blob) => download(state.showInfo.name.replace(' ', '_') + '_Electrical_Order.pdf', state.showInfo.electricalForm)}><u>Electrical Order (PDF)</u></p>
                                    }
                                </div>
                                <div className="text-center col-2 a">
                                    {state.showInfo.internetFormText &&
                                        <p onClick={(name, blob) => download(state.showInfo.name.replace(' ', '_') + '_Internet_Order.pdf', state.showInfo.internetForm)}><u>Internet Order (PDF)</u></p>
                                    }
                                </div>
                                <div className="text-center col-2 a">
                                    {state.showInfo.audioVisualFormText &&
                                        <p onClick={(name, blob) => download(state.showInfo.name.replace(' ', '_') + '_Audio_Visual_Order.pdf', state.showInfo.audioVisualForm)}><u>Audio Visual Order (PDF)</u></p>
                                    }
                                </div>
                                <div className="text-center col-2 a">
                                    {state.showInfo.laborFormText &&
                                        <p onClick={(name, blob) => download(state.showInfo.name.replace(' ', '_') + '_Labor_Services.pdf', state.showInfo.laborForm)}><u>Labor Services (PDF)</u></p>
                                    }
                                </div>
                                <div className="text-center col-3 a">
                                    {state.showInfo.supBoothFormText &&
                                        <p onClick={(name, blob) => download(state.showInfo.name.replace(' ', '_') + '_Supplemental_Booth_Furnishings.pdf', state.showInfo.supBoothForm)}><u>Supplemental Booth Furnishings (PDF)</u></p>
                                    }
                                </div>
                            </div>
                            {/*<div className="row pb-5 ml-5 mr-5" style={{ color: "red" }}>*/}
                            {/*    Due to an increase in shipping problems and delays throughout the country, Design-2-Part strongly recommends all exhibitors ship to the dedicated advance warehouse.*/}
                            {/*    This will help ensure that exhibit materials arrive on time and that you have everything you need at the show.*/}
                            {/*</div>*/}
                        </Fragment>
                    </div>

                    <div className="modal-footer">
                        <div className="form-group col-12 padding-25-10">
                            <button className="btn btn-submit margin-left-15" onClick={() => hideDrawer()}>Close</button>
                        </div>
                    </div>
                </>
            }
        </Drawer>
    );
}